module.exports = __webpack_public_path__ + "static/media/ZILLASLAB-MEDIUMITALIC_0.39cca6c1.OTF";